import map from './parser-map';
import Outcome from './MatchBetOutcome';
import helpers from '../helpers';

const betMap = map.match.bet;

class MatchBet {
  constructor(rawObj) {
    this.id = rawObj[betMap.id];
    this.displayId = rawObj[betMap.displayId];
    this.idMatchBet = rawObj[betMap.idMatchBet];
    this.idMatch = rawObj[betMap.idMatch];
    this.active = rawObj[betMap.active];
    this.position = parseInt(rawObj[betMap.position], 10) || helpers.maxInt;
    this.specialValue = rawObj[betMap.specialValue];
    this.name = rawObj[betMap.name];
    this.shortName = rawObj[betMap.shortName] || this.name;
    this.outcomes = rawObj[betMap.outcomes];
    this.mostBalanced = rawObj[betMap.mostBalanced];

    this.parseOutcomes();
  }

  parseOutcomes() {
    this.outcomes = _.sortBy(_.map(this.outcomes, val => new Outcome(val)), ['position']);
  }
}

export default MatchBet;
